
import { loadSectionTranslations } from '../../i18n-setup'
export default {
  name: 'sgh-copy-clipboard',
  props: {
    code: {
      default: '',
      type: String,
    },
    color: {
      default: '',
      type: String,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    category: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      copied: false,
    }
  },
  mounted() {
    loadSectionTranslations('cms')
  },
  computed: {
    isMobile() {
      return this.$mq == 'tablet' || this.$mq == 'tabletLandscape'
    },
  },
  methods: {
    copyPromoCode() {
      navigator.clipboard.writeText(this.code)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 3000)
    },
  },
}
